import React, { useMemo } from 'react'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { useDocumentRequests } from 'src/components/async/DocumentRequest'
import { useDRLRequest } from 'src/pages/Requests/requests.hooks'
import { useResolveSourceDisplayNames } from 'src/pages/Requests/useResolveSourceDisplayNames'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'
import { DropdownItemType } from './FilterDropdown.constants'

const REQUEST_SOURCE_CAPABILITIES = [CAPABILITY.CAN_VIEW_REQUESTS]

// The sources the account's requests came from, by display name.
export const RequestSourceFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const request = useDRLRequest()
    const { data, isLoading } = useDocumentRequests({ request })
    const requests = useMemo(() => data?.getItemsList() ?? [], [data])
    const displayNames = useResolveSourceDisplayNames(requests)

    const filterValues = useMemo<DropdownItemType[]>(() => {
      const seenSource = new Set<string>()
      const seenLabel = new Set<string>()
      const values: { value: string; label: string }[] = []
      requests.forEach((r) => {
        const source = r.getSource()
        if (!source || seenSource.has(source)) return
        seenSource.add(source)
        const label = displayNames.get(source)
        if (!label || seenLabel.has(label)) return
        seenLabel.add(label)
        values.push({ value: source, label })
      })
      return values.sort((a, b) => a.label.localeCompare(b.label))
    }, [requests, displayNames])

    return (
      <FilterDropdown
        filterParam={FilterParam.REQUEST_SOURCE}
        filterName={FilterName.REQUEST_SOURCE}
        filterValues={filterValues}
        isLoading={isLoading}
        isNested={isNested}
        requiredCapabilities={REQUEST_SOURCE_CAPABILITIES}
      />
    )
  },
)
